import { Time } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'productBetweenHoursItems'
})

export class ProductBetweenHoursPipe implements PipeTransform {
  transform(collection: Array<any>): any {
    const aux = [];
    const currentDate = new Date();
    const currentTime: Time = {
      hours: currentDate.getUTCHours(),
      minutes: currentDate.getUTCMinutes()
    };
    let currentDay = currentDate.getDay();
    if (currentDay === 0) {
      currentDay = 6;
    } else {
      currentDay -= 1;
    }
    if (collection && collection.length) {
      for (const item of collection) {
        if (item.product?.productHours?.length > 0)
        {
          const currentItemDay = item.product.productHours[currentDay];
          const start = currentItemDay.startTime;
          const updatedStart: Time = Object.assign({});
          updatedStart.hours = +(start.hours);
          updatedStart.minutes = +(start.minutes);
          const end = currentItemDay.endTime;
          const updatedEnd: Time = Object.assign({});
          updatedEnd.hours = +(end.hours);
          updatedEnd.minutes = +(end.minutes);
          if (currentItemDay.isAvailable
            && updatedStart.hours * 60 + updatedStart.minutes < currentTime.hours * 60 + currentTime.minutes
            && updatedEnd.hours * 60 + updatedEnd.minutes > currentTime.hours * 60 + currentTime.minutes
            ) {
              aux.push(item);
          } else if (!currentItemDay.isAvailable){
            aux.push(item);
          }
        } else {
          aux.push(item);
        }
      }
    }
    return aux;
  }
}
